<template>
  <Header_m/>
  <Concept_index_m></Concept_index_m>
  <Concept_page_m></Concept_page_m>
  <Footer_m></Footer_m>
</template>

<script>
import Concept_index_m from "@/components/CN_mobile/concept/Concept_index_m";
import Concept_page_m from "@/components/CN_mobile/concept/Concept_page_m";
import Footer_m from "@/components/CN_mobile/Footer_m";
import Header_m from "@/components/CN_mobile/Header_m";

export default {
  name: 'Concept_m',
  components: {Concept_page_m, Concept_index_m, Footer_m, Header_m},
}

</script>